import { render, staticRenderFns } from "./CadVersao.vue?vue&type=template&id=29b5b2de&"
import script from "./CadVersao.vue?vue&type=script&lang=js&"
export * from "./CadVersao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports